import { AxiosError } from 'axios';
import { isCancelledByUserError } from '../errors/createCanceledError';
import axiosRetry from 'axios-retry';

export const retryCondition = (error: AxiosError) => {
  if (isCancelledByUserError(error)) {
    return false;
  }

  // Retry always on 401, 502 and 504 status codes
  const retryStatusCodes = [401, 502, 504];
  if (retryStatusCodes.includes(error.response?.status as number)) {
    return true;
  }

  // And also retry on network errors or a 5xx error on an idempotent request
  return axiosRetry.isNetworkOrIdempotentRequestError(error) || error.code === 'ECONNABORTED';
};
